import React from "react";
import "./styles.css";

export default function PdfExport() {
  return (
    <main className="pdf-export-shell">
      <section className="pdf-export-card pdf-export-card--error" aria-labelledby="pdfExportTitle">
        <header className="pdf-export-header">
          <span className="pdf-export-eyebrow">Report PDF</span>
          <span className="pdf-export-status pdf-export-status--error">Needs attention</span>
        </header>
        <div className="pdf-export-body">
          <div className="pdf-export-content">
            <h1 id="pdfExportTitle">This PDF link is no longer supported</h1>
            <p className="pdf-export-message" role="status">
              For your security, PDF exports now require your current signed-in Reports session.
              Return to Reports, refresh your report, and export it again.
            </p>
            <a className="pdf-export-button" href="/reports">Return to Reports</a>
          </div>
        </div>
      </section>
    </main>
  );
}
